import { Component, Renderer2, Inject, OnInit, OnDestroy } from '@angular/core';
import { CommonModule, DOCUMENT } from '@angular/common';
import { RelevantNewsarticleComponent } from '../relevant-newsarticle/relevant-newsarticle.component';

interface ArticlePost {
  id: number;
  title: string;
  image: string;
  slug?: string;
}
@Component({
  selector: 'app-influential-business',
  imports: [CommonModule, RelevantNewsarticleComponent],
  standalone: true,
  templateUrl: './influential-business.component.html',
  styleUrl: './influential-business.component.scss'
})
export class InfluentialBusinessComponent implements OnInit, OnDestroy {
  private jsonLdScript: any;
  constructor(
    private renderer: Renderer2,
    @Inject(DOCUMENT) private _document: Document
  ) { }

  ngOnInit(): void {
    this.injectSchemaMarkup();
  }

  ngOnDestroy(): void {
    this.removeSchemaMarkup();
  }

injectSchemaMarkup(): void {
    const leadershipSchema = {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "WebPage",
          "@id": "https://www.kalpitatechnologies.com/kalpita-press-release/influential-business",
          "url": "https://www.kalpitatechnologies.com/kalpita-press-release/influential-business",
          "name": "Most Influential Business Leaders Shaping the Modern Industry, 2025 — Kalpita Technologies",
          "description": "Kube G is featured as one of the most influential business leaders shaping the modern industry in 2025, recognized for driving AI-enabled enterprise transformation through conscious innovation.",
          "speakable": {
            "@type": "SpeakableSpecification",
            "cssSelector": [
              ".softwaredev-heading",
              ".takeaways-section .takeaway-item p",
              ".section-title"
            ]
          },
          "significantLink": [
            "https://businesssuccessstory.com/a-soulful-architect-of-conscious-innovation-kube-g-building-innovative-ai-enabled-digital-solutions-that-transform-how-enterprises-operate-grow-and-compete/"
          ],
          "datePublished": "2025-01-01",
          "dateModified": "2025-03-01",
          "isPartOf": { "@type": "WebSite", "@id": "https://www.kalpitatechnologies.com/#website" }
        },
        {
          "@type": "BreadcrumbList",
          "@id": "https://www.kalpitatechnologies.com/kalpita-press-release/influential-business#breadcrumb",
          "itemListElement": [
            { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://www.kalpitatechnologies.com/" },
            { "@type": "ListItem", "position": 2, "name": "News", "item": "https://www.kalpitatechnologies.com/kalpita-press-release/inthenews" },
            { "@type": "ListItem", "position": 3, "name": "Influential Business Leaders 2025", "item": "https://www.kalpitatechnologies.com/kalpita-press-release/influential-business" }
          ]
        },
        {
          "@type": "TechArticle",
          "headline": "Most Influential Business Leaders Shaping the Modern Industry, 2025",
          "alternativeHeadline": "A Soulful Architect of Conscious Innovation — Kube G Building AI-Enabled Digital Solutions That Transform Enterprises",
          "articleBody": "Kube G has been recognized as one of the most influential business leaders shaping the modern industry in 2025, featured in Business Success Story as a soulful architect of conscious innovation...",
          "author": { "@type": "Organization", "name": "Business Success Story" },
          "publisher": {
            "@type": "Organization",
            "name": "Kalpita Technologies",
            "logo": { "@type": "ImageObject", "url": "https://www.kalpitatechnologies.com/assets/common/black-logo.png" }
          },
          "datePublished": "2025-01-01"
        },
        {
          "@type": "HowTo",
          "name": "How to Drive AI-Enabled Enterprise Transformation Through Conscious Innovation",
          "step": [
            { "@type": "HowToStep", "name": "Lead with Purpose", "text": "Adopt a leadership approach that combines innovation with empathy and human needs." },
            { "@type": "HowToStep", "name": "Embrace Conscious Innovation", "text": "Solve real business problems responsibly with meaningful technology." },
            { "@type": "HowToStep", "name": "Leverage AI for Efficiency", "text": "Deploy AI to optimize operations and accelerate enterprise scaling." },
            { "@type": "HowToStep", "name": "Design for Adaptability", "text": "Build digital transformation solutions meant for long-term flexibility." },
            { "@type": "HowToStep", "name": "Align Strategy with ROI", "text": "Ensure technology adoption results in measurable business growth." }
          ]
        },
        {
          "@type": "FAQPage",
          "mainEntity": [
            {
              "@type": "Question",
              "name": "Who is Kube G and why was he recognized in 2025?",
              "acceptedAnswer": { "@type": "Answer", "text": "Kube G is the CEO of Kalpita Technologies, recognized for driving AI-enabled enterprise transformation through a philosophy of conscious innovation." }
            },
            {
              "@type": "Question",
              "name": "What is conscious innovation?",
              "acceptedAnswer": { "@type": "Answer", "text": "It is a leadership philosophy where technology is built to solve real business problems responsibly while maintaining ethical and sustainable practices." }
            }
          ]
        },
        {
          "@type": "Organization",
          "@id": "https://www.kalpitatechnologies.com/#organization",
          "name": "Kalpita Technologies",
          "url": "https://www.kalpitatechnologies.com/",
          "logo": { "@type": "ImageObject", "url": "https://www.kalpitatechnologies.com/assets/common/black-logo.png" }
        },
        {
          "@type": "LocalBusiness",
          "@id": "https://www.kalpitatechnologies.com/#localbusiness",
          "name": "Kalpita Technologies — Austin Office",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "Suite #300, 3rd Floor, Building 2, 1250 South Capital of Texas Highway",
            "addressLocality": "Austin",
            "addressRegion": "TX",
            "postalCode": "78746",
            "addressCountry": "US"
          },
          "telephone": "+1-512-240-2484",
          "url": "https://www.kalpitatechnologies.com/"
        }
      ]
    };

    this.jsonLdScript = this.renderer.createElement('script');
    this.jsonLdScript.type = 'application/ld+json';
    this.jsonLdScript.text = JSON.stringify(leadershipSchema);
    this.renderer.appendChild(this._document.head, this.jsonLdScript);
  }
  
  removeSchemaMarkup(): void {
    if (this.jsonLdScript) {
      this.renderer.removeChild(this._document.head, this.jsonLdScript);
      this.jsonLdScript = null;
    }
  }
  articles: ArticlePost[] = [
    {
      id: 1,
      title: 'Lorem ipsum dolor sit amet, consectetur elit',
      image: '../../../../assets/resources/whitepaper/it-trends/art-card-one.webp'
    },
    {
      id: 2,
      title: 'Lorem ipsum dolor sit amet, consectetur elit',
      image: '../../../../assets/resources/whitepaper/it-trends/art-card-two.webp'
    },
    {
      id: 3,
      title: 'Lorem ipsum dolor sit amet, consectetur elit',
      image: '../../../../assets/resources/whitepaper/it-trends/art-card-three.webp'
    },
    {
      id: 4,
      title: 'Lorem ipsum dolor sit amet, consectetur elit',
      image: '../../../../assets/resources/whitepaper/it-trends/art-card-four.webp'
    },
    {
      id: 5,
      title: 'Lorem ipsum dolor sit amet, consectetur elit',
      image: '../../../../assets/resources/whitepaper/it-trends/art-card-five.webp'
    },
    {
      id: 6,
      title: 'Lorem ipsum dolor sit amet, consectetur elit',
      image: '../../../../assets/resources/whitepaper/it-trends/art-card-six.webp'
    },
    {
      id: 7,
      title: 'Lorem ipsum dolor sit amet, consectetur elit',
      image: '../../../../assets/resources/whitepaper/it-trends/art-card-seven.webp'
    },
    {
      id: 8,
      title: 'Lorem ipsum dolor sit amet, consectetur elit',
      image: '../../../../assets/resources/whitepaper/it-trends/art-card-eight.webp'
    }
  ];
  onArticleClick(article: ArticlePost): void {
    console.log('Article clicked:', article);
    // Handle navigation to article detail page
  }

  trackByArticle(index: number, article: ArticlePost): number {
    return article.id;
  }
}
